import { scope } from '#components/generics/js/selectors/scope.js'
import { helpers, elements } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as selector from './tools.js'

const { parseInt } = Number
const days20 = new WeakMap()
const nextPrevMonth = object(null, {
  next: date => {
    date.setMonth(date.getMonth() + 1)
  },
  prev: date => {
    date.setMonth(date.getMonth() - 1)
  }
})
const nextPrevYear = object(null, {
  next: date => {
    date.setYear(date.getFullYear() + 1)
  },
  prev: date => {
    date.setYear(date.getFullYear() - 1)
  }
})

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    action
  ) => {
    const { name } = action
    const container = closest(`.${helpers.dateSelector.elements.container}`, action)
    const { dataset } = container
    const { view, currentDay } = dataset
    const date = new Date()

    if (view === 'days') {
      const day20 = one(`.${helpers.dateSelector.elements.day}[data-target='day_20']`, container)
      const dayValue = days20.get(day20)

      if (dayValue) {
        const time = dayValue * 86400
        date.setTime(time * 1000)
      }

      nextPrevMonth[name]?.(date)
      selector.setCurrentDay(container, date)
      selector.setDays(container, date)
    } else if (view === 'months') {
      const month6 = one(`.${helpers.dateSelector.elements.month}[name='month_6']`, container)
      const { value } = month6

      if (value) {
        const time = value * 86400
        date.setTime(time * 1000)

        nextPrevYear[name]?.(date)
        selector.setCurrentDay(container, date)
        selector.setMonths(container, date)
      }
    } else if (view === 'years') {
      const yearsContainer = one(`.${helpers.dateSelector.elements.years}`, container)
      const buttonFirstYear = one(`.${elements.button}`, yearsContainer)
      const buttonLastYear = one(`.${elements.button}:last-child`, yearsContainer)
      const year = name === 'prev' ? parseInt(buttonFirstYear.value, 10) - 24 : parseInt(buttonLastYear.value, 10) + 1

      if (year) {
        const time = currentDay * 86400
        date.setTime(time * 1000)
        date.setFullYear(year)

        selector.setCurrentDay(container, date)
        selector.setYears(container, date)
      }
    }
  }
})

export const setDay20 = (day20, day = null) => {
  // On passe par un scope et non pas l'attribut "value" parce que l'action jour peut être une ancre ou un button
  const { dayValue } = scope(day20)
  days20.set(day20, day ?? dayValue)

  queueMicrotask(async () => {
    await removed(day20)
    days20.delete(day20)
  })
}

export default action => {
  const container = closest(`.${helpers.dateSelector.elements.container}`, action)
  const day20 = one(`.${helpers.dateSelector.elements.day}[data-target='day_20']`, container)

  setDay20(day20)

  onClick.listen(action)
}
